var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogoDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 16,
    viewBox: "0 0 148 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vita Student Logo",
    clipPath: "url(#clip0_320_4689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 84",
    d: "M11.1521 0.961238L6.92577 10.4457L2.70361 0.961238H0L6.88617 15.6779H6.96538L13.8307 0.961238H11.1521ZM16.6761 15.4611H19.142V0.961238H16.6761V15.4611ZM22.0562 0.961238V3.14997H26.9694V15.4611H29.4353V3.14997H34.3475V0.961238H22.0562ZM40.1841 5.77332L42.3728 10.8043H37.9954L40.1841 5.77332ZM40.1445 0.702759L33.3177 15.4611H36.0015L37.148 12.8367H43.2223L44.3687 15.4611H47.0525L40.2226 0.702759H40.1445Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 85",
    d: "M62.8907 2.22148L61.5878 4.25388C60.5803 3.39962 59.2984 2.93741 57.9775 2.9521C56.5371 2.9521 55.5709 3.5639 55.5709 4.88548C55.5709 5.97047 56.2609 6.42385 58.5935 6.89807C62.2236 7.66726 63.467 8.94923 63.467 11.1786C63.467 13.8822 61.4346 15.6968 58.1599 15.6968C56.173 15.7597 54.2332 15.0851 52.7141 13.803L54.0555 11.7508C55.1845 12.8232 56.6809 13.4232 58.2381 13.4278C59.915 13.4278 61 12.718 61 11.3954C61 10.3302 60.1912 9.75802 57.8826 9.28483C54.2525 8.49585 53.0883 7.15342 53.0883 5.00326C53.0872 2.43931 55.0383 0.683115 57.9973 0.683115C59.754 0.638319 61.4756 1.17956 62.8907 2.22148Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 86",
    d: "M77.2915 3.12935H72.3794V15.4404H69.9124V3.12935H65.0002V0.939575H77.2915V3.12935Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 87",
    d: "M90.7172 10.2917C90.7172 13.5477 88.8411 15.6979 85.2714 15.6979C81.6809 15.6979 79.8069 13.5477 79.8069 10.2917V0.939575H82.2729V10.1375C82.2729 12.1104 83.2786 13.432 85.2714 13.432C87.2444 13.432 88.2512 12.1104 88.2512 10.1375V0.939575H90.7172V10.2917Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 88",
    d: "M98.5896 0.939575H94.1079V15.4415H98.5896C103.561 15.4415 106.442 12.7577 106.442 8.18115C106.442 3.60462 103.517 0.939575 98.5896 0.939575ZM98.5302 13.1725H96.577V3.22836H98.5302C102.042 3.22836 103.956 5.04397 103.956 8.18011C103.956 11.3371 102.062 13.1715 98.5302 13.1715",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 89",
    d: "M118.372 3.20856H111.684V7.01591H117.521V9.16712H111.684V13.1725H118.53V15.4415H109.217V0.939575H118.371L118.372 3.20856Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 90",
    d: "M133.093 15.6971H133.019L124.179 6.44401V15.4407H121.713V0.683472H121.793L130.631 9.9168V0.939866H133.097L133.093 15.6971Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 91",
    d: "M148.032 3.12935H143.12V15.4404H140.659V3.12935H135.745V0.939575H148.037L148.032 3.12935Z",
    fill: "#101010"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_320_4689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogoDesktop);
export default __webpack_public_path__ + "static/media/header-logo-desktop.9e3f22572b47ce182ad7440d2bbb1eb6.svg";
export { ForwardRef as ReactComponent };